import React from 'react';

var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const IcApplications = /* @__PURE__ */ __name((properties) => /* @__PURE__ */ React.createElement("svg", {
  fill: "none",
  height: "24",
  width: "24",
  xmlns: "http://www.w3.org/2000/svg",
  ...properties
}, /* @__PURE__ */ React.createElement("path", {
  clipRule: "evenodd",
  d: "M3.5 4A1.5 1.5 0 0 0 2 5.5v3h20v-3A1.5 1.5 0 0 0 20.5 4h-17Zm2 2.25a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm2 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm4-1a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z",
  fill: "var(--mds-nav-icon-accent)",
  fillRule: "evenodd"
}), /* @__PURE__ */ React.createElement("path", {
  d: "M2 10h5v10H3.5A1.5 1.5 0 0 1 2 18.5V10Zm6.5 0H22v4.25H8.5V10Zm0 5.75H22v2.75a1.5 1.5 0 0 1-1.5 1.5h-12v-4.25Z",
  fill: "var(--mds-nav-icon-weak)"
})), "IcApplications");

export { IcApplications };
//# sourceMappingURL=ic-applications.js.map
